// extracted by mini-css-extract-plugin
module.exports = {"box":"Archive_box__Gby49","flexBody":"Archive_flexBody__1mGY4"};